import {BaseWizardStep, REMOVED} from "../base.wizard.step";
import { cloneDeep, find, first, isArray, isEmpty, isObject, map } from 'lodash';
import { ApiService } from "@nrwl/common-lib";
import { AbstractControl } from "@angular/forms";


export class ActiveTestWizardStep extends BaseWizardStep {
  isDestinationStep:any;
  isCloudAgents:any;
  isPCAgentDataValid:any;
  isPCAgentSelected:any;
  isProxyDataValid:any;
  isProxySelected:any;
  contentType:any;
  locations:any;
  proxyKey:any;
  addNewItemCallback:any;

  constructor(apiService:ApiService,  config, parent:any) {
    super(apiService, config, parent);
    
    this.isProxyDataValid = false;
    this.isProxySelected = false;

    if (this.config.def.subContent) {
      this.subContent = new ActiveTestWizardStep(apiService,  config.def.subContent, this);
    }
    // is bound as input to some wrapped components/used as callback
    this.addNewItemCallback = () => {
      this.addNewItem();
    };
  }


  metaDataValueChange(componentId, key, newValue, isValid = true) {
    super.metaDataValueChange(componentId, key, newValue, isValid);
    if (key === "sip-proxy-originator" || key === "sip-proxy-destination") {
      this.isProxyDataValid = isValid;
    }
  }

//------------------------------------------- Step Control -----------------------------------------------------------

  _resetStep() {
    super._resetStep();
  }

  addNewItem() {
    if (!this.isNewItemDataValid()) {
      return;
    }
    this._addNewItemToCurrentList(true);
    if (this.parent.showServices) {
      this.subContent._resetStep();
      this.selectedTab = 0;
    }
  }

  isNewItemDataValid(step = this.subContent) {
    const hasEmptyInputs = find(step.config.def.inputsRequired, (key) => {
      if (isObject(key)) {
        return find(key, (items, subKey) => {
          return !find(items, (item) => {
            //return !isEmpty(step.inputs[subKey]) && !isEmpty(step.inputs[subKey][item]);
          });
        });
      } else if (isEmpty(step.inputs[key])) {
        if (!isEmpty(this.sharedOutput[key])) {
          step.inputs[key] = this.sharedOutput[key];
          return false;
        } else {
          return true;
        }
      }
    });

    return !hasEmptyInputs;
  }

  _addNewItemToCurrentList(selectNewItem) {
    const data = isArray(this.dataSource) ? first(this.dataSource) : this.dataSource;
    const newItem = cloneDeep(this.subContent.inputs);

    newItem.tests = map(this.sharedOutput.testTypes, (test) => {
      return {
        id: test.id,
        label: test.label
      };
    });
    data.list.push(newItem);

    if (selectNewItem) {
      this.onItemClick(this.config.def.outputs[0], newItem);
    }
  }

  //------------------------------------------- Click Events -----------------------------------------------------------


  selectTypeContent(type, key, showSubContent = false) {
    this.contentType = type;
    this.isProxySelected = false;
 
    if (type === "application") {
      this.itemSelected = false;
      this.output.type = "application";
      this.subContent.toggleSubContent(true);
    } 
    else if (type === "originator") {
      this.itemSelected = false;
      this.output.type = "originator";
      this.subContent.toggleSubContent(true);
    } 
    else if (type === "destination") {
      this.itemSelected = false;
      this.output.type = "destination";
      this.subContent.toggleSubContent(true);
    } 
    else if (type === "edit") {
      this.itemSelected = false;
      this.output.type = "edit";
      this.subContent.toggleSubContent(true);
    } 
    else if (type === "proxy") {
      this.subContent.toggleSubContent(true);
      this.proxyKey = key;
    }
  }













//-------------------------------------------------Helpers------------------------------------------------------------



  closeSubContentStep() {
    this.subContent.toggleSubContent(false);
  }
}
